import { render, staticRenderFns } from "./RecetasAuto.vue?vue&type=template&id=24eb0d0b&"
import script from "./RecetasAuto.vue?vue&type=script&lang=js&"
export * from "./RecetasAuto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports